module.exports = __webpack_public_path__ + "static/ellieheadshot-9c5b08cb0958aceb196f2a07a636bb61.jpg";